import { Card, Space, Tabs, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { TasksTab } from './components/TasksTab/TasksTab';
import { TriggersTab } from './components/TriggersTab/TriggersTab';
import { useTasksTriggersPage } from './hooks/useTasksTriggersPage';

const { Title, Paragraph } = Typography;

export function TasksTriggersPageContainer() {
  const { t } = useTranslation('maintenance');
  const { tabLabels } = useTasksTriggersPage();

  return (
    <Space direction="vertical" size={24} style={{ width: '100%' }}>
      <div>
        <Title level={2} style={{ marginBottom: 8 }}>
          {t('tasksTriggers.title')}
        </Title>
        <Paragraph type="secondary" style={{ marginBottom: 0 }}>
          {t('tasksTriggers.description')}
        </Paragraph>
      </div>

      <Card style={{ borderRadius: 16, border: '1px solid #e2e8f0' }}>
        <Tabs
          defaultActiveKey="tasks"
          items={[
            {
              key: 'tasks',
              label: tabLabels.tasks,
              children: <TasksTab />,
            },
            {
              key: 'triggers',
              label: tabLabels.triggers,
              children: <TriggersTab />,
            },
          ]}
        />
      </Card>
    </Space>
  );
}
